


































































import { Component, Vue, Prop } from 'vue-property-decorator';
import _kebabCase from 'lodash.kebabcase';
import { IGameItemForSaleByGala } from '~/store/games/types';
import { ISortOption } from '~/store/types';
import StoreItemCard from '~/components/Store/StoreItemCard.vue';
import SortDrawer from '~/components/SortDrawer.vue';
import BottomDrawerDialog from '~/components/UIComponents/BottomDrawerDialog.vue';

@Component({
  components: {
    StoreItemCard,
    SortDrawer,
    BottomDrawerDialog,
  },
})
export default class ItemList extends Vue {
  @Prop(Array) readonly data!: IGameItemForSaleByGala[];
  @Prop(String) readonly listTitle!: string;
  @Prop(Function) readonly viewAll!: () => void;
  @Prop({ type: Boolean, default: false }) readonly toMint!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showSortButton!: boolean;
  @Prop({ type: Boolean, default: false }) readonly page!: boolean;
  @Prop({ type: Boolean, default: false }) readonly showNewLabel!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly shouldRowColumnsMatch!: boolean;

  sortBy: ISortOption = {
    title: 'price high to low',
    property: !this.page ? 'avgPrice' : 'listPrice',
    direction: -1,
  };
  sortDrawer = false;
  comingSoon = false;

  get listId() {
    return _kebabCase(this.listTitle);
  }

  get sortOptions(): ISortOption[] {
    const options = [
      {
        title: 'price high to low',
        property: !this.page ? 'price' : 'listPrice',
        direction: -1,
      },
      {
        title: 'price low to high',
        property: !this.page ? 'price' : 'listPrice',
        direction: 1,
      },
    ];
    if (!this.page) {
      const quantityOptions = [
        { title: 'quantity high to low', property: 'quanitity', direction: -1 },
        { title: 'quantity low to high', property: 'quanitity', direction: 1 },
        { title: 'rarity (descending)', property: 'rarity', direction: -1 },
        { title: 'rarity (ascending)', property: 'rarity', direction: 1 },
      ];
      return [...options, ...quantityOptions];
    } else {
      return options;
    }
  }

  get itemsForSale() {
    return !this.page
      ? this.data
      : [...this.data].sort((a: any, b: any) =>
          a[this.sortBy.property] > b[this.sortBy.property]
            ? this.sortBy.direction
            : this.sortBy.direction * -1,
        );
  }

  get itemListLength() {
    return this.itemsForSale.length;
  }

  get showViewAllCard() {
    return (
      this.shouldRowColumnsMatch &&
      this.viewAll &&
      (this.itemListLength === 5 ||
        (this.itemListLength === 3 &&
          (this.$vuetify.breakpoint.width < 600 ||
            this.$vuetify.breakpoint.width > 1449)) ||
        this.itemListLength === 1 ||
        (this.itemListLength === 2 && this.$vuetify.breakpoint.width >= 600))
    );
  }

  goToItem(item: any) {
    // TODO: remove coming soon when Exchange is up and running
    if (this.comingSoon) {
      return;
    }
    const link = !this.page
      ? `/games/buy-item/${item.baseId}`
      : `/games/items/${item.baseId}`;
    this.$router.push(link);
  }

  handleSort(option: ISortOption) {
    if (this.page) {
      this.sortBy = option;
    } else {
      this.$emit('sort', {
        sortBy: option.property,
        direction: option.direction === -1 ? 'descending' : 'ascending',

        base: 'GALA',
        rel: 'GALA',
      });
    }
  }
}
